




































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ASSET_URL } from '../../common/config';
import { CLOSE_PRODUCT_SHEETS } from '../../common/constants';
import Product from '../../common/model/Product';
import Tag from '../../common/model/Tag';
import { eventBus } from '../../main';
import brandModule from '../../store/modules/brand.module';

@Component({
  components: {},
})
export default class BrandProductCard extends Vue {
  // Data
  @Prop() product: Product;

  cdnUrl = ASSET_URL;

  openSheet = false;

  placeholderImg = require('@/assets/admin/placeholder.jpg');

  get brandSecondaryColor(): string {
    if (!brandModule.brand || !brandModule.brand.secondary_color) { return 'black'; }
    return brandModule.brand.secondary_color;
  }

  get productTitle(): string {
    if (!this.product) { return ''; }
    return this.product.title;
  }

  get productImage() : string {
    if (!this.product) { return ''; }
    return this.product.image;
  }

  get coaFile(): string {
    if (!this.product || !this.product.pdf_url) { return ''; }
    return this.product.pdf_url;
  }

  get productTags(): Array<Tag> {
    if (!this.product) { return []; }
    return this.product.tags;
  }

  get productTHC(): string {
    if (!this.product) { return ''; }
    return this.product.thc_percentage;
  }

  get productBestFor(): string {
    if (!this.product) { return ''; }
    return this.product.best_for;
  }

  get productStrain(): string {
    if (!this.product) { return ''; }
    return this.product.strain;
  }

  get productStrainGroup(): string {
    if (!this.product) { return ''; }
    return this.product.strain_group;
  }

  get productDosage(): string {
    if (!this.product) { return ''; }
    return this.product.dosage;
  }

  get productDescription(): string {
    if (!this.product) { return ''; }
    return this.product.description;
  }

  get brandFontColor(): string {
    if (!brandModule.brand) {
      return '#FFFFFF';
    }
    return brandModule.brand.font_color;
  }

  // Methods
  created(): void {
    // Listen for the close sheet event and close the sheet if it's triggered from another product card
    eventBus.$on(CLOSE_PRODUCT_SHEETS, this.closeSheet);
  }

  closeSheet(): void {
    this.openSheet = false;
  }

  showProductDetails(): void {
    eventBus.$emit(CLOSE_PRODUCT_SHEETS);
    this.openSheet = true;
  }
}
